import React from 'react';
import PropTypes from 'prop-types';

const StandardButton = ({
  text,
  type,
  onClick,
  bgColorStyle,
  roundedStyle,
  textColorStyle,
  textSizeStyle,
  letterSpacingStyle,
  fontFamilyStyle,
  heightStyle,
  widthStyle,
  otherStyles,
  hoverStateStyle,
  disabled,
  id,
  hidden,
  isSecondary,
  outline,
}) => {
  const baseStyles = 'focus:outline-none disabled:cursor-default leading-6';
  const disabledStyle = isSecondary ? 'border disabled:border-light-grey-blue-two disabled:text-light-grey-blue-two disabled:bg-white disabled:opacity-50' : 'disabled:bg-light-grey-blue-two disabled:opacity-50';
  const borderStyle = isSecondary ? 'border border-light-grey-blue-five' : '';
  const bgColorClass = isSecondary ? 'bg-white' : bgColorStyle;
  const textColorClass = isSecondary ? 'text-dark' : textColorStyle;
  const hoverStateClass = isSecondary ? 'hover:bg-secondary-hover' : hoverStateStyle;
  let classNames = `${hidden ? 'hidden' : ''} ${baseStyles} ${process.env.REACT_APP_NAME === 'golfDigest' ? '' : roundedStyle} ${disabledStyle} ${borderStyle} ${heightStyle} ${widthStyle} ${bgColorClass} ${textColorClass} ${textSizeStyle} ${letterSpacingStyle} ${fontFamilyStyle} ${otherStyles} ${disabled ? '' : hoverStateClass}`;

  if (outline) classNames = 'font-primary font-semibold w-full h-12 text-4 leading-5 tracking-0.16 text-dark border border-dark rounded-2 flex justify-center items-center focus:outline-none disabled:border-light-grey-blue-two disabled:text-light-grey-blue-two';

  return (
    <button
      type={type}
      className={classNames}
      onClick={onClick}
      disabled={disabled}
      id={id}
    >
      {text}
    </button>
  );
};

StandardButton.defaultProps = {
  text: 'OK',
  type: 'button',
  hoverStateStyle: 'md:hover:bg-thirtySeventh',
  bgColorStyle: 'bg-primary',
  roundedStyle: 'rounded-3',
  textColorStyle: 'text-white',
  textSizeStyle: 'text-4',
  letterSpacingStyle: '-tracking-0.2',
  fontFamilyStyle: 'font-primary font-bold',
  heightStyle: 'h-14',
  widthStyle: 'w-full',
  otherStyles: '',
  onClick: null,
  disabled: false,
  id: '',
  hidden: false,
  isSecondary: false,
  outline: false,
};

StandardButton.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  type: PropTypes.oneOf(['submit', 'button', 'reset']),
  onClick: PropTypes.func,
  hoverStateStyle: PropTypes.string,
  bgColorStyle: PropTypes.string,
  roundedStyle: PropTypes.string,
  textColorStyle: PropTypes.string,
  textSizeStyle: PropTypes.string,
  letterSpacingStyle: PropTypes.string,
  fontFamilyStyle: PropTypes.string,
  heightStyle: PropTypes.string,
  widthStyle: PropTypes.string,
  otherStyles: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  hidden: PropTypes.bool,
  isSecondary: PropTypes.bool,
  outline: PropTypes.bool,
};

export default StandardButton;
